export const paramsToString = (params) => {
  const ids = params?.map((value) => value.id);
  const len = ids.length;

  if (len === 0) return "";

  return ids.reduce((acc, res) => {
    return acc + `,${res}`;
  });
};
